import React from 'react';

export default function BrandSection() {
  return (
    <section id="sobre" className="py-24 lg:py-32" style={{ background: '#FFD6E0' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image composition */}
          <div className="relative order-2 lg:order-2">
            <div className="relative">
              {/* Main image */}
              <div className="rounded-2xl overflow-hidden aspect-[4/5]">
                <img
                  src="/assets/images/1000028469-1789414769215.jpg"
                  alt="Mulher negra elegante e confiante no estúdio Mãos Mágicas em Maputo"
                  className="w-full h-full object-cover" />
                
              </div>
              {/* Floating accent card */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-5 shadow-lg border border-border max-w-[180px]">
                <span className="gold-line mb-3 block" />
                <p className="font-serif text-2xl font-light text-dark-brown leading-tight">Cuidado<br /><em className="italic text-burnt-rose">com alma.</em></p>
              </div>
              {/* Background decoration */}
              <div className="absolute -top-4 -left-4 w-full h-full rounded-2xl -z-10" style={{ background: '#FFC2D4' }} />
            </div>
          </div>

          {/* Text content */}
          <div className="order-1 lg:order-1">
            <span className="gold-line mb-6 block" />
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4">
              A Nossa Essência
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light leading-[1.1] text-dark-brown mb-8">
              Mais do que<br />
              depilação.<br />
              <em className="italic text-burnt-rose">Um momento<br />para si.</em>
            </h2>
            <div className="space-y-5 text-foreground/70 leading-relaxed">
              <p className="text-base lg:text-lg">
                Na Mãos Mágicas, cada sessão é pensada para ser muito mais do que um tratamento. É um momento de cuidado genuíno, onde a sua privacidade, o seu conforto e o seu bem-estar são a nossa prioridade.
              </p>
              <p className="text-base">
                Trabalhamos com técnicas de depilação a cera que respeitam a sua pele, num ambiente acolhedor e discreto, no coração de Maputo.
              </p>
              <p className="text-base">
                Porque cuidar de si não é um luxo — é uma necessidade.
              </p>
            </div>

            {/* Pillars */}
            <div className="grid grid-cols-2 gap-4 mt-10">
              {[
              { label: 'Privacidade', desc: 'Ambiente discreto e reservado' },
              { label: 'Higiene', desc: 'Materiais descartáveis e esterilizados' },
              { label: 'Profissionalismo', desc: 'Atendimento especializado' },
              { label: 'Conforto', desc: 'Espaço pensado para si' }]?.
              map((item) =>
              <div key={item?.label} className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <div className="w-1 h-4 bg-burnt-rose rounded-full" />
                    <span className="font-semibold text-sm text-dark-brown">{item?.label}</span>
                  </div>
                  <p className="text-xs text-foreground/60 pl-3">{item?.desc}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}